export default __webpack_public_path__ + "static/media/ciela.2aff97e7.png";